import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SET_SUSAR_REPORT, SAVE_SUSAR, UP_DATA_INITIAL, GET_SUSAR, SUBMIT_SUSAR } from 'store/key';
import { produce } from 'utility/general';
import { setGlobalLoading } from 'store/global/reducer';
import API from 'api/call';
import { safeSaga } from 'store';
import store from 'store';
import { setGlobal } from 'store/global/reducer';
import { statusLookup } from 'utility/lookup';

const initialState = {
    reportData: null,
    remoteDetail: {
        actualStudyStartDate: null,
        isNotYetStarted: null,
        recruitedSubjectNo: null,
        totalNumberReportsSubmitted: null,
        anyRecommendation: null,
        isAlterationRequired: null,
        addSupplements: [],
        deleteSupplements: [],
        signedFileName: '',
        signedFileId: '',
    },
    rows: [],
    remoteDocIds: [],
    isLoading: false,
    forceErrorDisplay: false,
    oldData: {
        actualStudyStartDate: null,
        isNotYetStarted: null,
        recruitedSubjectNo: null,
        totalNumberReportsSubmitted: null,
        anyRecommendation: null,
        isAlterationRequired: null,
    },
};
function* upDataInitial(action) {
    const { key, value } = action.payload;
    const { susarReport } = yield select();
    susarReport[key] = value;
    yield put({
        type: SET_SUSAR_REPORT,
        payload: susarReport,
    });
}

function* getSusar(action) {
    const { docType, reportId, appId, isFormCreate, onPermissionError } = action.payload;
    const { susarReport } = yield select();
    susarReport.isLoading = true;
    susarReport.forceErrorDisplay = false;

    yield put({
        type: SET_SUSAR_REPORT,
        payload: susarReport,
    });

    try {
        let data = { docType: docType };
        if (isFormCreate) {
            data.appId = appId;
            data.reportId = null;
        } else {
            data.reportId = reportId;
        }

        const res = yield call(API.postApprovalActivities.getReportDetail, data);
        const detail = res.data.result;
        susarReport.remoteDetail = detail;
        susarReport.remoteDetail.addSupplements = [];
        susarReport.remoteDetail.deleteSupplements = [];
        susarReport.rows = detail.supplementDocuments ?? [];
        susarReport.remoteDocIds = detail.supplementDocuments?.map((item) => item.id);

        susarReport.oldData.actualStudyStartDate = detail.actualStudyStartDate;
        susarReport.oldData.isNotYetStarted = detail.isNotYetStarted;
        susarReport.oldData.recruitedSubjectNo = detail.recruitedSubjectNo;
        susarReport.oldData.totalNumberReportsSubmitted = detail.totalNumberReportsSubmitted;
        susarReport.oldData.anyRecommendation = detail.anyRecommendation;
        susarReport.oldData.isAlterationRequired = detail.isAlterationRequired;

        if (!isFormCreate) {
            let subNo = null,
                statusDisplay = null;
            if (detail.subNo) {
                subNo = detail.subNo;
            }
            if (detail.lastStatus !== null) {
                statusDisplay =
                    statusLookup.find((item) => {
                        return detail.lastStatus === item.key;
                    })?.statusDisplay || null;
            }
            store.dispatch(
                setGlobal({
                    postApprovalReportData: {
                        [reportId]: {
                            showNavigationSubNo: subNo,
                            showNavigationStatus: statusDisplay,
                        },
                    },
                }),
            );
        }
    } catch (error) {
        console.log('get susar report detail failed:', error);
        return onPermissionError?.();
    }

    susarReport.isLoading = false;
    yield put({
        type: SET_SUSAR_REPORT,
        payload: susarReport,
    });
}

function* saveSusar(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId } = action.payload;
    const { susarReport } = yield select();

    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            recruitedSubjectNo,
            totalNumberReportsSubmitted,
            anyRecommendation,
            isAlterationRequired,
            addSupplements,
            deleteSupplements,
        } = susarReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            recruitedSubjectNo,
            totalNumberReportsSubmitted,
            isAlterationRequired,
            anyRecommendation,
            addSupplements,
            deleteSupplements,
            appId: appId ?? susarReport.remoteDetail.appId,
            signedFileId,
        };

        if (!isFormCreate) {
            data.reportId = reportId;
        }

        const res = yield call(API.susarReport.saveSusar, data);

        const newReportId = res.data.result.reportId;
        callback?.(newReportId);
    } catch (error) {
        console.log('create/save susar failed:', error);
    }
    setGlobalLoading(false);
}

function* submitSusar(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId } = action.payload;
    const { susarReport } = yield select();

    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            recruitedSubjectNo,
            totalNumberReportsSubmitted,
            anyRecommendation,
            isAlterationRequired,
            addSupplements,
            deleteSupplements,
        } = susarReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            recruitedSubjectNo,
            totalNumberReportsSubmitted,
            isAlterationRequired,
            anyRecommendation,
            addSupplements,
            deleteSupplements,
            appId: appId ?? susarReport.remoteDetail.appId,
            signedFileId,
        };

        if (!isFormCreate) {
            data.reportId = reportId;
        }

        try {
            const response = yield call(API.susarReport.submitSusar, data);
            if (response.status === 400) {
                throw new Error('Bad Request: The server returned a 400 status.');
            }
            callback?.();
        } catch (error) {
            console.log('submit susar failed:', error);
            throw error; // Re-throw the error if needed
        }

        callback?.();
    } catch (error) {
        console.log('submit susar failed:', error);
    }
    setGlobalLoading(false);
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SUSAR_REPORT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchSusarReport() {
    yield takeEvery(UP_DATA_INITIAL, safeSaga(upDataInitial));
    yield takeEvery(GET_SUSAR, safeSaga(getSusar));
    yield takeEvery(SAVE_SUSAR, safeSaga(saveSusar));
    yield takeEvery(SUBMIT_SUSAR, safeSaga(submitSusar));
}

export default reducer;
